import { Component, OnInit } from '@angular/core';
import { Role } from '../../../shared/models/role';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Store, select, props } from '@ngrx/store';

import * as fromAuth from '../../../store';
import * as fromAuthActions from '../../../store/actions';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-roles',
  templateUrl: './modal-roles.component.html',
  styleUrls: ['./modal-roles.component.scss']
})
export class ModalRolesComponent implements OnInit {

  formRole: FormGroup;
  roles: Role[];

  constructor(
    private fb: FormBuilder,
    private store: Store<fromAuth.AuthState>,
    private router: Router
  ) { }

  ngOnInit() {
    this.formRole = this.createForm();
    this.store.pipe(
      select(fromAuth.selectSessionUserRoles)
    ).subscribe(roles => {
      return this.roles = roles;
    });
  }

  private createForm() {
    return this.fb.group({
      role: ['', Validators.required]
    });
  }

  get invalidForm() {
    return this.formRole.invalid;
  }

  setRole() {
    const { role } = this.formRole.value;
    const roleSelected = this.roles.find((item) => item.code === role);
    this.store.dispatch(fromAuth.setCurrentRole({ role: roleSelected }));
    // this.store.dispatch(fromAuth.goHome());
  }

}
